import React from 'react';
import PropTypes from 'prop-types';
import AlreadyPurchasedCourses from './Courses/AlreadyPurchasedCourse.component';
import NotPurchasedCourses from './Courses/NotPurchasedCourse.component';
import { FormContainer } from '../../../CreateRoutes/CreateForm.styles';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadcrumbsComponent.component';

const UserCoursesInner = ({ user, courses }) => {
  const filterNotPurchasedCourses = (courses) => {
    if (user && courses) {
      const mappedUserCourses = user?.courses?.map(
        (course) => course?.courseId
      );
      return courses?.filter(
        (course) => !mappedUserCourses?.includes(course?._id)
      );
    }
    return [];
  };
  const notPurchasedCourses = filterNotPurchasedCourses(courses);

  return (
    <FormContainer>
      <BreadCrumbs
        one="Admin Dashboard - User"
        oneLink={`/admin/user-home/${user?._id}`}
        two="User Courses"
      />
      <h2>USER COURSES</h2>
      <div>
        {user?.courses?.length < 1 ? (
          <span>User has no courses</span>
        ) : (
          <ul className="courses-grid">
            {user?.courses?.map((c) => (
              <li key={c?._id}>
                <a
                  className="courseHover"
                  href={`/admin/edit-user/${user?._id}/course/${c?._id}`}
                  style={{ color: c?.complete ? 'green' : 'red' }}
                >
                  {c?.courseName}
                </a>
              </li>
            ))}
          </ul>
        )}
        {/* // courses, userId, userName, email */}
        <AlreadyPurchasedCourses
          courses={courses}
          userId={user._id}
          email={user.email}
          userName={`${user.firstName} ${user.lastName}`}
        />
        <NotPurchasedCourses
          notPurchasedCourses={notPurchasedCourses}
          userId={user._id}
          email={user.email}
          userName={`${user.firstName} ${user.lastName}`}
        />
      </div>
    </FormContainer>
  );
};
UserCoursesInner.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    courses: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string,
        courseName: PropTypes.string,
        complete: PropTypes.bool,
      })
    ),
  }).isRequired,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      courseName: PropTypes.string,
    })
  ).isRequired,
};

export default UserCoursesInner;
